import {
  GET_SEND_PRODUCT_DL_REQUEST,
  GET_SEND_PRODUCT_DL_SUCCESS,
  GET_SEND_PRODUCT_DL_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const sendProductDL = (token, values) => (dispatch) => {
  dispatch({ type: GET_SEND_PRODUCT_DL_REQUEST });
  const newData = {
    values
};
  return axios({
    method: "POST",
    url: `${BASEURL}create/producttobergenDL`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData
  })
    .then((response) => {
      return dispatch({
        type: GET_SEND_PRODUCT_DL_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SEND_PRODUCT_DL_ERROR,
        payload: [],
      });
    });
};
